// Upload Store - SAT V4 Zone
import { create } from 'zustand';
import type { UploadStatus } from '../types';

interface UploadState {
  uploadedFiles: {
    teachers: UploadStatus;
    pupils: UploadStatus;
    parents: UploadStatus;
    rooms: UploadStatus;
    subjects: UploadStatus;
    classes: UploadStatus;
    curriculum: UploadStatus;
  };
  setUploadStatus: (key: keyof UploadState['uploadedFiles'], status: UploadStatus) => void;
  resetUpload: (key: keyof UploadState['uploadedFiles']) => void;
  resetAllUploads: () => void;
}

const initialStatus: UploadStatus = {
  status: 'pending',
};

const initialUploadedFiles = {
  teachers: { ...initialStatus },
  pupils: { ...initialStatus },
  parents: { ...initialStatus },
  rooms: { ...initialStatus },
  subjects: { ...initialStatus },
  classes: { ...initialStatus },
  curriculum: { ...initialStatus },
};

export const useUploadStore = create<UploadState>((set) => ({
  uploadedFiles: initialUploadedFiles,

  setUploadStatus: (key, status) =>
    set((state) => ({
      uploadedFiles: {
        ...state.uploadedFiles,
        [key]: status,
      },
    })),

  resetUpload: (key) =>
    set((state) => ({
      uploadedFiles: {
        ...state.uploadedFiles,
        [key]: { ...initialStatus },
      },
    })),

  resetAllUploads: () =>
    set(() => ({
      uploadedFiles: initialUploadedFiles,
    })),
}));

export default useUploadStore;

